<template>
  <div class="page">
    <div class="main-container">
      <div class="form-container">

        <div class="header">
          <img src="/img/hadiethshop.jpeg"/>
        </div>

        <div class="form-body">
          <h2 class="title">Login</h2>

          <label style="text-align: center">Je kunt de gebruikersnaam en wachtwoord van de prestashop CMS gebruiken.</label>
          <form v-on:submit.prevent class="the-form" @submit="login()">

            <label class="text-danger" v-if="error">Username / Password invalid</label>

            <label for="email">Email</label>
            <input type="email" name="email" id="email" v-model="email" placeholder="Enter your email">

            <label for="password">Password</label>
            <input type="password" name="password" id="password" v-model="password" placeholder="Enter your password">

            <input type="submit" value="Log In">

          </form>

        </div>


      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import Vue from "vue"
  export default {
    name: "LoginForm",
    data() {
      return {
        rememberMe: false,
        email: "",
        password: "",
        error: false,
        user: {
          name: "not-set"
        }
      };
    },
    methods: {
      login() {
        let data = {
          email: this.email,
          password: this.password
        }
        var self = this
        axios.post("/api/login", data)
          .then((response) => {
            console.log("Logged in")
            self.$router.push("/admin/overview")
          })
          .catch((errors) => {
            this.error = true
            console.log("Cannot log in")
          })
      },
      getUserData: function() {
        let self = this
        axios.get("/api/user")
          .then((response) => {
            console.log(response)
            self.$set(this, "user", response.data.user)
            self.$router.push("/admin/overview")
          })
          .catch((errors) => {
          })
      }
    },
    mounted() {
      this.getUserData()
    }
  };
</script>

<style scoped>

  .page {
    margin: 0;
    padding: 0;
    color: #222222;
    height: 100vh;
    background-color: #efefef;
    background-image: url("/img/login-background.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;
    padding: 20px;
    overflow-x: hidden;
    font-family: 'Muli', sans-serif, -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, sans-serif;
    outline: none;
  }

  .main-container {
    max-width: 900px;
    margin: 0 auto;
  }

  a {
    color: inherit;
    outline: none;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  .header {
    background-color: #fff;
    margin: 0;
    padding: 20px;
  }

  .header img {
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  .form-container {
    max-width: 450px;
    margin: 0 auto;
  }

  .form-body {
    background-color: #333333;
    overflow: hidden;
    padding: 50px;
    color: #ffffff;
    border-radius: 3px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  @media only screen and (max-width: 500px) {
    .form-body {
      padding: 50px 40px;
    }
  }

  @media only screen and (max-width: 455px) {
    .form-body {
      padding: 45px 30px;
    }
  }

  @media only screen and (max-width: 340px) {
    .form-body {
      padding: 30px 20px;
    }
  }

  .form-body .title {
    margin: 0;
    text-align: center;
    font-weight: normal;
  }

  .social-login ul {
    list-style-type: none;
    margin: 30px 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
  }

  .social-login ul li {
    flex: 1 auto;
  }

  .social-login ul li a {
    background-color: #56385a;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 15px;
    color: #e6e6e6;
    font-weight: bold;
    text-decoration: none;
    transition: background-color .3s;
  }

  .social-login ul li a::before {
    content: '';
    width: 30px;
    height: 30px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 30px;
    margin-right: 5px;
  }

  .social-login ul li a:hover {
    background-color: #fff199;
    color: #0e090e;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  @media only screen and (max-width: 400px) {
    .social-login ul {
      flex-direction: column;
    }

    li.google,
    li.fb {
      margin: 0;
    }

    li.google {
      margin-bottom: 10px;
    }
  }

  ._or {
    text-align: center;
    margin-bottom: 20px;
    color: #d9d9d9;
  }

  .the-form {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }

  .the-form label {
    margin-bottom: 5px;
    color: #e6e6e6;
    font-weight: bold;
  }

  .the-form [type="email"],
  .the-form [type="password"] {
    padding: 15px;
    font-size: 16px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    margin-bottom: 15px;
    transition: background .3s;
    color: #e6e6e6;
  }

  .the-form [type="email"]::placeholder,
  .the-form [type="password"]::placeholder {
    color: rgba(255, 255, 255, 0.3);
  }

  .the-form [type="email"]:hover,
  .the-form [type="password"]:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  .the-form [type="email"]:focus,
  .the-form [type="password"]:focus {
    background: #ffffff;
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
    border-color: #4a304d;
    color: #222222;
  }

  .the-form [type="email"]:focus::placeholder,
  .the-form [type="password"]:focus::placeholder {
    color: #666666;
  }

  .the-form [type="submit"] {
    background: #ffb37b;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 18px;
    font-size: 20px;
    border-radius: 3px;
    cursor: pointer;
    margin-top: 20px;
    color: black;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .the-form [type="submit"]:hover {
    opacity: .9;
  }

  .form-footer div {
    text-align: center;
    padding: 25px 20px;
    font-size: 18px;
    color: #e6e6e6;
  }

  .form-footer div a {
    color: #ffb37b;
  }
</style>
